import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Capture.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";

const Capture = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
    }, [])
    const shareImage = async () => {
        if (navigator.share) {
            try {
                const file = new File([arg.blob], 'image.jpeg', { type: 'image/jpeg' });
                await navigator.share({
                    title: '分享圖片',
                    text: '',
                    files: [file],
                });
            } catch (error) {
                console.error('分享失败', error);
            }
        } else {
            downloadImage();
        }
    };

    const downloadImage = () => {
        const link = document.createElement('a');
        link.href = arg.dataUrl;
        link.target = "_blank";
        link.download = 'image.png'; // 设置下载文件的默认名称
        document.body.appendChild(link);
        link.click();
    };
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "Capture"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <IconButton onClick={e => {
                                        setInProp(false)
                                    }}>
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                </div>
                                <div className={styleUi.view}>
                                    <img src={arg.dataUrl} />
                                    <YStyled.BTN4 onClick={e => {
                                        shareImage()
                                    }}>
                                        <YStyled.Row style={{ padding: "0 .5rem" }}>
                                            <YStyled.Span size={17} fontWeight={400} fontFamily="SF Pro">分享</YStyled.Span>
                                            <img src="./assets/ui/Share.png" />
                                        </YStyled.Row>
                                    </YStyled.BTN4>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Capture);